import MTagList from './MTagList.vue';

MTagList.install = (app) => {
  app.component('MTagList', MTagList);
};

export { MTagList };
